export const NODE_ENV = process.env.NODE_ENV

export const TEMPLATE = 'multi-options'

export const VIEWS = {
  MAIN: 'MAIN',
  ORDER: 'ORDER',
  FINAL_ORDER: 'FINAL_ORDER'
}

export const CURRENCIES = {
  $: 'USD',
  '€': 'EUR'
}
